import React from 'react'
import PropTypes from 'prop-types'
import globals from '../../globals'
import { VOIP_PAYG } from '../../constants'

export const Plan = (props) => {
    const formatPrice = (price) => {
        if (price === VOIP_PAYG) {
            return <span style={{ fontSize: '14px' }}>Pay-as-you-go</span>
        }

        if (typeof price === 'object') {
            return price
        }

        return `${globals.addDecimals(price, true)}/mth`
    }

    const hasSpecial = (item) => item.special && item.special.planPrice
    const Special = (item) => (
        <div className='text-right mb-2' style={{ marginTop: '-15px' }}>
            for {item.special.duration}<br />
            then <span className='bold'>{formatPrice(item.price)}</span> thereafter
        </div>
    )

    const f2fPrice = (item) => (
        <p className="bold">
          {item.title !== "Everyday" && item.title !== "Extra Value" ? (
            <React.Fragment>
              <span className="line-through mr-1">
                  {formatPrice(item.price)}
              </span>
              <span>{formatPrice(item.flipToFibrePriceDiscount)}</span>
            </React.Fragment>
          ) : (
            formatPrice(item.price)
          )}
        </p>
      )

    const totalMinCost = () => {
        return globals.addDecimals((props.plan.totalMinCost ? props.plan.totalMinCost : props.plan.price), true)
    }

    const dataBonus = (plan) => {
        if (plan.title === 'ExeSim Saver 4G' || plan.title === 'ExeSim Max 5G') {
            return <p className='font-small m-0'>Enjoy Slash My Bill™ discounts when you bundle with Exetel</p>;
        }

        if (plan.title === 'ExeSim Plus 4G') {
            return <p className='font-smaller bold m-0'>+ 20GB BONUS data<br /><span className='font-tiny regular'>1st recharge if activated by 29/09/22</span></p>
        }

        if (plan.title === 'ExeSim Value 4G' || plan.title === 'ExeSim Extra Value 4G') {
            return <p className='font-smaller bold m-0'>+ 10GB BONUS data<br /><span className='font-tiny regular'>1st recharge if activated by 29/09/22</span></p>
        }

        return null;
    }

    return (
        <div className={`compare-plan-mobile mb-3 ${props.isExisting ? 'existing-plan' : ''} ${props.planSelected(props.plan)}`} onClick={() => props.handleSelect(props.plan.id, props.plan)}>
            <div className='header d-flex align-items-center'>
                <div className='d-inline-block w-50'>
                    <span dangerouslySetInnerHTML={{ __html: props.plan.title }} />
                    {props.plan.data && !props.isExisting ? <div className='mt-1'><small>{props.plan.data}</small></div> : ''}
                </div>
                <div className='d-inline-flex justify-content-end align-items-center ml-auto'>
                    <div>
                        <span className='bold'>{formatPrice(hasSpecial(props.plan) ? props.plan.special.planPrice : props.plan.flipToFibrePriceDiscount ? f2fPrice(props.plan) : props.plan.price)}</span>
                    </div>
                    <div className='tick ml-2' />
                </div>
            </div>
            <div className='body font-small'>
                {hasSpecial(props.plan) ? Special(props.plan) : ''}
                {props.plan.speed ? <p className='m-0 my-2'>Speed: {props.plan.speed}</p> : ''}
                {props.plan.eveningSpeed ? <p className='m-0 my-2'>{props.plan.eveningSpeed} Evening speed 7-11pm</p> : ''}
                {dataBonus(props.plan)}
                {props.plan.data ? <p className='m-0 my-2'>Data: {props.plan.data}</p> : ''}
                {props.plan.dataAdditional ? props.plan.dataAdditional : ''}
                {props.plan.features
                    ? props.plan.features.map((item, key) => {
                        return <p key={key} className='m-0 my-2' dangerouslySetInnerHTML={{ __html: item }} />
                    })
                    : ''}
                {props.plan.additionalText1 ? props.plan.additionalText1 : ''}
                {props.plan.additionalText2 ? props.plan.additionalText2 : ''}
                {props.plan.html ? props.plan.html : ''}
                <p className='m-0 mt-5 hide-on-existing'><small>
                    Total min cost {props.plan.price === VOIP_PAYG ? '$0' : totalMinCost()}
                </small>
                </p>
            </div>
        </div>
    )
}

Plan.propTypes = {
    plan: PropTypes.object.isRequired,
    isExisting: PropTypes.bool,
    planSelected: PropTypes.func.isRequired,
    handleSelect: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./resources/js/components/ComparePlans/MobileElements.js